var global_data = {
    islogin: false
  }
export default global_data;